import React from 'react';
import MultiSMTPConfigModal from '../modals/MultiSMTPConfigModal';
import { connect } from 'react-redux';
import MoreVert from '../../images/sharp-more_vert-24px.svg';
import { Button, Popover } from 'reactstrap';
import DeleteSMTPConfigModal from '../modals/DeleteSMTPConfigModal';

class SMTPConfigTablePopoverItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popoverOpen: false,
      editModalVisible: false,
      deleteModalVisible: false,
    };
  }

  toggleDeleteConfig = () => {
    this.setState({
      deleteModalVisible: !this.state.deleteModalVisible,
      popoverOpen: false,
    });
  };

  toggleEditModal = () => {
    this.setState({
      editModalVisible: !this.state.editModalVisible,
      popoverOpen: false,
    });
  };

  toggle = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  };

  render() {
    const { localisation } = this.props.userReducer;

    //seperate style for hidden input.
    var style = {};
    style.display = 'none';
    let popoverItems = [];
    const { id } = this.props;
    let tick = <div />;

    let editSMTPConfigModalPopup = {};
    let deleteSMTPConfigModal = {};

    //Bug 11684:Under Printer Destinations, the delete doesn't fit in edit destination box

    popoverItems.push(
      <a
        class="s-list-default-btn-default s-popup-menu-no-icon"
        onClick={this.toggleEditModal}
        title="Edit"
      >
        <div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-create" />{' '}
        {localisation['popover_edit']
          ? localisation['popover_edit'].element_lang
          : ''}
      </a>
    );
    popoverItems.push(
      <a
        class="s-list-default-btn-default s-with-icon"
        onClick={this.toggleDeleteConfig}
        title="Delete"
      >
        <div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete">
          
        </div>{' '}
        {localisation['popover_delete']
          ? localisation['popover_delete'].element_lang
          : ''}
      </a>
    );

    //popoverItems.push(<a class="s-list-default-btn-default s-with-icon" onClick={this.toggleDeleteDocument}  title="Delete"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete"></div> Delete</a>)
    //popoverItems.push(<a class="s-list-default-btn-default s-with-icon" onClick={this.editdocument} title="Edit"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />Edit</a>)

    if (this.state.editModalVisible) {
      editSMTPConfigModalPopup = (
        <MultiSMTPConfigModal
          refresh={this.props.refresh}
          visible={this.state.editModalVisible}
          toggle={this.toggleEditModal}
          settings={this.props.settings}
          fileid={this.props.fileid}
          settingsId={this.props.settingsId}
          type={this.props.type}
        />
      );
    } else editSMTPConfigModalPopup = <div />;

    if (this.state.deleteModalVisible) {
      deleteSMTPConfigModal = (
        <DeleteSMTPConfigModal
          visible={this.state.deleteModalVisible}
          refresh={this.props.refresh}
          toggle={this.toggleDeleteConfig}
          settings={this.props.settings}
          fileid={this.props.fileid}
          settingsId={this.props.settingsId}
          type={this.props.type}
        />
      );
    } else deleteSMTPConfigModal = <div />;

    return (
      <span>
        {tick}
        <Button
          className="s-record-picker s-fonticon-btn s-btn-menus"
          color="danger"
          id={id}
          onClick={this.toggle}
        >
          <img src={MoreVert} />
        </Button>
        <Popover
          placement="top"
          hideArrow={true}
          isOpen={this.state.popoverOpen}
          target={id}
          toggle={this.toggle}
        >
          {popoverItems}
        </Popover>
        {editSMTPConfigModalPopup}
        {deleteSMTPConfigModal}
      </span>
    );
  }
}

export default connect((state) => state)(SMTPConfigTablePopoverItem);
